import styled from 'styled-components';
import { hideVisually } from 'polished';

export const StyledLog = styled.div`
  ${hideVisually}
  -webkit-user-select: none;
  user-select: none;
`;

export default StyledLog;
